import { Injectable, OnDestroy } from '@angular/core';
import { EnvService } from './env.service';
import { UserService } from './services/user.service';

declare let Weavy: any;
declare let WeavyLib: any;

@Injectable({
  providedIn: 'root'
})
export class WeavyChatService {

  weavy;

  constructor(private userService:UserService, private envService: EnvService) {
    
  }

  init(): void {
    this.weavy = new Weavy({ init: true, url: this.envService.WEAVY_URL ,tokenFactory: () => this.getAccessToken(), tz: this.getTimezone()});
  }

  openChat(uid){
    this.init();
    let wyChat = new WeavyLib.WyChat();
    wyChat.uid= uid;
    wyChat.features = {"attachments":false};
    return wyChat;
  }


  getAllConversations(){
    this.init();
    return this.weavy.get('/api/conversations');   
  }

  getConversationById(roomId){
    this.init();
    return this.weavy.get('/api/conversations/'+roomId);   
  }

  syncUserName(username, image, uid){
    this.init();
    return this.weavy.post('/api/users/'+uid, "PUT", JSON.stringify({name: username, picture: image}));   
  }

  async getAccessToken(){
    return new Promise<string>((resolve, reject) => {
      this.userService.getWeavyAccessToken().subscribe(
        (response) => {
          if(response['status'] && response['result'] && response['result']['access_token']){
             resolve(response['result']['access_token']);
          } else {
             resolve('')
          }
        },
        (error) => {
          reject(''); 
        }
      );
    });
  }

  getTimezone(){
    let timezone = Intl.DateTimeFormat('en', { timeZoneName: 'long' }).formatToParts(new Date())
    .find(part => part.type === 'timeZoneName')
    .value;
    return timezone;
  }

}